import Home from './components/Home/Home'
import Header from './components/Header/Header';
import About from './components/About/About';

import { HashLink as Link } from 'react-router-hash-link';
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <div style={{paddingTop: '60px'}}> <Home />
      <Router>
        <Switch><Link to='/#about' component={About} /></Switch>
      </Router>
      </div>
    </div>
  );
}

export default App;
